export function capitalize (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function formatCurrency (price, currency) {
  if (isNaN(parseFloat(price))) {
    return price;
  }

  price = parseFloat(price);

  switch (currency) {
    case 'USD':
      return '$' + price;

    case 'BS':
      return price + ' Bs.';

    case 'TRY':
    case 'TL':
      return '₺ ' + price;

    default:
      return price + ' ' + currency;
  }
}



// WEBPACK FOOTER //
// ./src/util/filters.js